import { TFirmwareAssignmentAction, FirmwareAssignmentActionTypes } from './firmwareAssignmentActions';
import { IFirmwareAssignmentState } from './firmwareAssignmentContext';

export const firmwareAssignmentReducer = (
	state: IFirmwareAssignmentState,
	action: TFirmwareAssignmentAction,
): IFirmwareAssignmentState => {
	switch (action.type) {
		case FirmwareAssignmentActionTypes.SET_FIRMWARE_FOR_ASSIGN:
			return {
				...state,
				firmwareForAssign: action.payload.firmwareForAssign,
			};
		case FirmwareAssignmentActionTypes.CHANGE_SEARCH_STRING:
			return {
				...state,
				searchString: action.payload.searchString,
				IDsSelectedFirmware: [],
				currentPage: 1,
			};
		case FirmwareAssignmentActionTypes.CHANGE_SEARCH_STRING_FOR_ALL_CUSTOMERS:
			return {
				...state,
				searchStringForAllCustomers: action.payload.searchStringForAllCustomers,
			};
		case FirmwareAssignmentActionTypes.CHANGE_SEARCH_STRING_FOR_RESTAURANTS:
			return {
				...state,
				searchStringForRestaurants: action.payload.searchStringForRestaurants,
			};
		case FirmwareAssignmentActionTypes.CHANGE_SEARCH_STRING_FOR_FIRMWARES:
			return {
				...state,
				searchStringForFirmwares: action.payload.searchStringForFirmwares,
			};
		case FirmwareAssignmentActionTypes.CHANGE_TYPE_FIRMWARE:
			return {
				...state,
				IDSelectedTypeFirmware: action.payload.IDSelectedTypeFirmware,
				IDsSelectedFirmware: [],
				isUnassignedFirmware: false,
				currentPage: 1,
			};
		case FirmwareAssignmentActionTypes.RESET_SELECTED_CONTROLS:
			return {
				...state,
				IDSelectedTypeFirmware: null,
				isUnassignedFirmware: false,
				IDsSelectedFirmware: [],
				currentPage: 1,
				searchString: '',
			};
		case FirmwareAssignmentActionTypes.CHANGE_UNASSIGNED_FIRMWARE_STATUS:
			return {
				...state,
				isUnassignedFirmware: action.payload.isUnassignedFirmware,
				IDsSelectedFirmware: [],
				currentPage: 1,
			};
		case FirmwareAssignmentActionTypes.SET_IDS_SELECTED_FIRMWARE:
			return {
				...state,
				IDsSelectedFirmware: action.payload.IDsSelectedFirmware,
			};
		case FirmwareAssignmentActionTypes.CHANGE_ACTIVE_ITEM_TO_DISPLAY:
			return {
				...state,
				activeItemToDisplay: action.payload.activeItemToDisplay,
			};
		case FirmwareAssignmentActionTypes.SET_SHOW_BREADCRUMBS:
			return {
				...state,
				isShowBreadcrumbs: action.payload.isShowBreadcrumbs,
			};
		case FirmwareAssignmentActionTypes.SET_ALL_CUSTOMERS:
			return {
				...state,
				allCustomers: action.payload.allCustomers,
			};
		case FirmwareAssignmentActionTypes.SET_IDS_SELECTED_CUSTOMERS:
			return {
				...state,
				IDsSelectedCustomers: action.payload.IDsSelectedCustomers,
				restaurants: action.payload.restaurants,
				IDsSelectedRestaurants: action.payload.IDsSelectedRestaurants,
				firmwares: action.payload.firmwares,
			};
		case FirmwareAssignmentActionTypes.SET_IDS_SELECTED_RESTAURANTS:
			return {
				...state,
				IDsSelectedRestaurants: action.payload.IDsSelectedRestaurants,
				firmwares: action.payload.firmwares,
			};
		case FirmwareAssignmentActionTypes.SET_FIRMWARES:
			return {
				...state,
				firmwares: action.payload.firmwares,
				IDsSelectedFirmware: action.payload.IDsSelectedFirmware,
			};
		case FirmwareAssignmentActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case FirmwareAssignmentActionTypes.CHANGE_CURRENT_PAGE:
			return {
				...state,
				currentPage: action.payload.currentPage,
				IDsSelectedFirmware: [],
			};
		case FirmwareAssignmentActionTypes.RESET_CHANGES:
			return {
				...state,
				activeItemToDisplay: 'customers',
				IDsSelectedCustomers: {},
				restaurants: [],
				IDsSelectedRestaurants: {},
				firmwares: [],
				typeOfModalWindow: null,
			};
		default:
			return state;
	}
};
